import styled from 'styled-components';
export const Wrapper = styled.div `
  position: relative;
  min-height: 2.5rem;
  display: flex;
  align-items: center;

  > div {
    margin: 0 0.5rem;
  }
`;
